
<div ref="anchor" class="discountAnchor" :class="{fullWidth}">
  <DiscountBanner :auto-open-on-mobile="autoOpenOnMobile"/>
  <transition name="discountSlide" :css="!suppressFloating">
    <div v-if="showFloating && !suppressFloating" ref="floating" class="floatingDiscount" :class="{mobile}" :style="floatingStyle">
      <DiscountBanner :compact="mobile" :tile="mobile"/>
    </div>
  </transition>
</div>
